// The clicked record's own id, offered next to the columns when a button URL is built
export const BUTTON_URL_RECORD_ID_VARIABLE_KEY = '$itemId'
